module.exports = __webpack_public_path__ + "img/cursor.58ce4dc7.svg";